import React from 'react';
import { Button, Badge, Modal } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { Divider } from '@mui/material';
import default_img from '../../../../../images/product/productcategory.png';

const ViewProdCat = ({ show, onClose, data }) => {
    const onInit = () => { };

    if (!data) return null;
 

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Product Category</h3>
                    <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>

                <div className="modal-body">
                    {/* Top: Image and Name */}
                    <div className="d-flex mb-3 align-items-center gap-3 mt-3">
                        <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                            <div data-src={data.productcategory_img || default_img} className='border w-120px h-100px rounded'>
                                <img src={data.productcategory_img || default_img} alt={data.productcategory_name} className='w-125px h-100px' />
                            </div>
                        </LightGallery>
                        <div>
                            <label className='text-green font-w500 fs-4'>{data.productcategory_name}</label>
                            <div>
                                <svg className="me-2 mb-1" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#025d3a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#025d3a" stroke-width="1.5"></path> </g></svg>
                                {/* <Badge bg="success" className='text-white fs-7'>{data.schedule_name}</Badge> */}
                                <label className='text-black fs-6 me-2'>{data.schedule_name}</label>
                            </div>
                        </div>
                    </div>

                    {/* Description */}
                    <div className="mb-4">
                        <div className="text-black fs-6 font-w500">Description</div>
                        <div className="text-black fs-7 mt-1">
                            &emsp;&emsp;{data.description}
                        </div>
                    </div>

                    <Divider />

                    {/* Product Details */}
                    {/* {data.products?.length > 0 && (
                        <>
                            <div className="mt-3 mb-2">
                                <span className="text-red fs-4 font-w600">Product Details</span>
                            </div>

                            <div className="scroll-y mh-225px py-2">
                                {data.products.map((product, idx) => (
                                    <div key={idx} className="card mb-2">
                                        <div className="card-body px-2 py-2">
                                            <div className="d-flex align-items-center gap-3">
                                                <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                                    <div data-src={product.product_image} className='border w-60px h-60px rounded'>
                                                        <img src={product.product_image} alt={product.product_name} className='w-60px h-60px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w500 fs-5'>{product.product_name}</label>
                                                    <div>
                                                        <label className='text-black fs-6'>Item Count: </label>
                                                        <Badge bg="info" className='text-white fs-8 py-0 px-1'>
                                                            {product.item_count || 0}
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )} */}
                </div>
            </div>
        </Modal>
    );
};

export default ViewProdCat;
